<template>
  <v-dialog v-model="value" width="90%" scrollable @click:outside="close">
    <v-card>
			<v-card-title class="title primary--text mb-2 secondary">
				<v-icon class="mr-3" color="primary">mdi-plus-circle</v-icon>
        <span v-translate class="mr-1">Add Open Formulas</span>
			</v-card-title>
			<v-card-text>
        <v-row no-gutters>
          <v-col cols="12" md="12" class="mt-3">
            <v-progress-linear
              :active="loading"
              :indeterminate="loading"
              top
              color="primary"
            ></v-progress-linear>
            <template v-if="!loading">
              <ProductList
                ref="formulaList"
                :products="formulas"
                type="formula"
                context="provider"
                :admin="false"
                :infiniteScroll="true"
                @load-more="page += 1; makeRequest()"
              />
            </template>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary darken-1" text @click="close">
          <translate>Cancel</translate>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text @click="addOpenFormulas" :loading="savingFormulas" :disabled="disabledAdd">
          <translate>Add</translate>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ProductList from "@/components/products/ProductList.vue";
import axios from "axios";
import Vue from "vue";

export default {
  name: "EntityClassicFormulas",
  props: ["value"],
  components: {
    ProductList
  },
  data: () => ({
    loading: false,
    page: 1,
    search: "",
    formulas: [],
    savingFormulas: false
  }),
  computed: {
    disabledAdd() {
      return this.formulas.filter(f => f.product.selected).length == 0;
    }
  },
  methods: {
    makeRequest() {
			clearTimeout(this._timerId);
			if(this.page == 1) this.loading = true;
			this._timerId = setTimeout(() => {
				axios
					.get("/mtc/formulas", {
						params: {
							context: "products_page",
							keyword: this.search.toLowerCase(),
							page: this.page,
              classic: true,
              substances: true
						}
					})
					.then(response => {
						console.log(response.data);
            response.data.forEach(f => {
              Vue.set(f.product, 'selected', false);
              f.product.ingredients.forEach(i => {
                Vue.set(i, 'selected', true);
              });
            });
						if(this.page == 1) this.formulas = response.data;
						else {
							this.$refs.formulaList.addProducts(response.data);
						}
						this.loading = false;
					})
					.catch(error => {
						console.log(error);
						this.loading = false;
					});
			}, 300);
		},
    addOpenFormulas() {
      let selectedFormulas = this.formulas.filter(f => f.product.selected);

      let selectedFormulasFiltered = selectedFormulas.map(f => {
        let ingredientsFiltered = f.product.ingredients.filter(i => i.selected);
        f.product.ingredients = ingredientsFiltered;
        return f;
      });
      console.log(selectedFormulasFiltered);
      this.savingFormulas = true;
      axios
				.post("/mtc/formulas/add-customizable", selectedFormulasFiltered)
				.then(response => {
					console.log(response.data);
          this.savingFormulas = false;
          this.close();
          this.$emit('get-formulas');
				})
				.catch(error => {
					console.log(error);
					this.savingFormulas = false;
				});
    },
    close() {
      this.page = 1;
      this.formulas = [];
      this.$emit('input', false);
    }
  },
  watch: {
    value(v) {
      if(v) this.makeRequest();
    }
  }
}
</script>
